
import { MeasureTypeEnum, PlanItemStateEnum, RepeatFrequencyEnum } from '@/libs/Api';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { Component, Prop, VModel, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class PlanItemStateChip extends Vue {
    @VModel() innerValue!: PlanItemStateEnum;
    @Prop() readonly!: boolean;
    @Prop() rules!: [any[]];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) white!: boolean;
    @Prop({ default: false }) dense!: boolean;
    @Prop({ default: false }) hideDetails!: boolean;
    @Prop({ default: false }) clearable!: boolean;
    @Prop({ default: false }) onlyMeasures!: boolean;
    @Prop({ default: 0 }) maxWidth!: number;
    @Prop({ default: false }) applyMinimalWidth!: boolean;

    get chipColor() {
        switch (this.innerValue) {
            case PlanItemStateEnum.WaitingToPerform:
                return 'orange';
            case PlanItemStateEnum.NeedsToCreateMeasures:
                return 'blue-grey';
            case PlanItemStateEnum.NeedsToPerformMeasures:
                return 'blue';
            case PlanItemStateEnum.NeedsToVerifyMeasures:
                return 'purple';
            case PlanItemStateEnum.AllMeasuresVerified:
                return 'cyan';
            case PlanItemStateEnum.PerformedWithoutFindings:
                return 'purple';
            case PlanItemStateEnum.WaitingForApproval:
                return 'blue-grey';
            case PlanItemStateEnum.Approved:
                return 'green';
            case PlanItemStateEnum.Declined:
                return 'red';
            case PlanItemStateEnum.Closed:
                return 'green';
            case PlanItemStateEnum.ClosedWithoutFindings:
                return 'green';
            case PlanItemStateEnum.ClosedWithIssueEscalation:
                return 'green';
        }
        return 'black';
    }

    get chipIcon() {
        switch (this.innerValue) {
            case PlanItemStateEnum.WaitingToPerform:
                return 'mdi-timer-sand';
            case PlanItemStateEnum.NeedsToCreateMeasures:
                return 'mdi-clipboard-plus-outline';
            case PlanItemStateEnum.NeedsToPerformMeasures:
                return 'mdi-hammer-wrench';
            case PlanItemStateEnum.NeedsToVerifyMeasures:
                return 'mdi-magnify';
            case PlanItemStateEnum.AllMeasuresVerified:
                return 'mdi-check-decagram-outline';
            case PlanItemStateEnum.PerformedWithoutFindings:
                return 'mdi-clipboard-check-outline';
            case PlanItemStateEnum.WaitingForApproval:
                return 'mdi-account-clock-outline';
            case PlanItemStateEnum.Approved:
                return 'mdi-check-circle-outline';
            case PlanItemStateEnum.Declined:
                return 'mdi-close-circle-outline';
            case PlanItemStateEnum.Closed:
                return 'mdi-lock-check-outline';
            case PlanItemStateEnum.ClosedWithoutFindings:
                return 'mdi-lock-check-outline';
            case PlanItemStateEnum.ClosedWithIssueEscalation:
                return 'mdi-alert-decagram-outline';
        }
        return 'mdi-circle-outline';
    }
}
